var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book_today"},[_c('div',{staticClass:"container"},[_c('a',{attrs:{"href":_vm.parsedCta.url,"target":_vm.parsedCta.target},domProps:{"innerHTML":_vm._s(_vm.parsedCta.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/BookToday.vue